module.exports = __webpack_public_path__ + "static/img/banner1.5ef1df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site-image/banner1.png
// module id = UuZG
// module chunks = 169